import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { icons } from '../icons';
import { AnalyticsService } from './core/services/analytics-service';
import { ApiService } from './core/services/api.service';
import { AppConfig } from './core/services/app-config.service';
import { AppCookiesService } from './core/services/app-cookies.service';
import { IdleService } from './core/services/idle.service';
import { InstantNotificationService } from './core/services/instant-notification.service';
import { LogRocketService } from './core/services/log-rocket.service';
import { MaintenanceService } from './core/services/maintenance.service';
import { VersionCheckService } from './core/services/version-check.service';
import { MessagesStoreService } from './shared/services/messages-store.service';
import { DialogMsgComponent } from './shared/components/dialog-msg/dialog-msg.component';
import { MAX_WIDTH_90, WIDTH_560 } from './shared/configs/dialog-config';
import { MatDialog } from '@angular/material/dialog';
import { BannerRealtimeService } from './core/services/banner-realtime.service';

@Component({
standalone: false,
  selector: 'app-root',
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  constructor(
    private library: FaIconLibrary,
    private apiService: ApiService,
    private idleService: IdleService,
    private appCookiesService: AppCookiesService,
    private versionCheck: VersionCheckService,
    private logRocketService: LogRocketService,
    private appConfig: AppConfig,
    private maintenanceService: MaintenanceService,
    private breakpointObserver: BreakpointObserver,
    private analytics: AnalyticsService,
    private notification: InstantNotificationService,
    private messageService: MessagesStoreService,
    private dialog: MatDialog,
    private bannerRealtime: BannerRealtimeService,
  ) {
    library.addIcons(...icons);
  }

  public ngOnInit(): void {
    this.idleService.init();
    this.apiService.init();
    this.bannerRealtime.init();
    this.appCookiesService.init();
    this.versionCheck.init('/version.json').subscribe(() => {
      this.logRocketService.init();
    });
    this.subscribeMessages();
  }


  private subscribeMessages() {
    this.messageService.state$.subscribe(
      value => {
        if (!!value) {
          this.dialog
            .open(DialogMsgComponent, {
              width: value.width ? value.width : WIDTH_560,
              maxWidth: MAX_WIDTH_90,
              disableClose: !value.closeable,
            });
        }
      },
    );
  }
}
